window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  },
  onEditClick: function() {
    $('.js-edit-toggle').on('click', function(evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));
      var isExpanded = $evtTarget.attr('aria-expanded') === 'true';
      $evtTarget
        .toggleClass('cart__edit--active')
        .attr('aria-expanded', !isExpanded);
      $updateLine.toggleClass('cart__update--show');
    });
  },
  handleInputQty: function() {
    $('.cart__qty-input').on('change', function(evt) {
      var $input = $(evt.target);
      var value = $input.val();
      var itemKey = $input.data('quantity-item');
      var $itemQtyInputs = $('[data-quantity-item=' + itemKey + ']');
      $itemQtyInputs.val(value);
    });
  }
};

Shopify.AjaxifyCart = (function($) {

  // Some configuration options.
  // I have separated what you will never need to change from what
  // you might change.

  var _config = {
    addToCartBtnLabel:             'Add to cart',
    checkoutBtnLabel:              'Buy Now',
    addedToCartBtnLabel:           'Thank you!',
    addingToCartBtnLabel:          'Adding...',
    soldOutBtnLabel:               'Sold Out',
    howLongTillBtnReturnsToNormal: 1000, // in milliseconds.
    cartCountSelector:             '.cartCount span',
    cartTotalSelector:             '#cart-price',
    feedbackPosition:              'belowForm',
    addToCartBtnSelector:          '[data-add-to-cart]',
    checkoutBtnSelector:          '[data-checkout]',
    addToCartFormSelector:         'form[action="/cart/add"]',
    shopifyAjaxAddURL:             '/cart/add.js',
    shopifyAjaxCartURL:            '/cart.js'
  };

  // We need some feedback when adding an item to the cart.
  // Here it is.
  var _showFeedback = function(success, html, $addToCartForm) {
    $('.ajaxified-cart-feedback').remove();
    var feedback = '<p class="ajaxified-cart-feedback ' + success + '">' + html + '</p>';
    switch (_config.feedbackPosition) {
      case 'aboveForm':
        $addToCartForm.before(feedback);
        break;
      case 'belowForm':
        $addToCartForm.after(feedback);
        break;
      case 'nextButton':
      default:
        $addToCartForm.find(_config.addToCartBtnSelector).after(feedback);
        break;
    }
    // If you use animate.css
    // $('.ajaxified-cart-feedback').addClass('animated bounceInDown');
    $('.ajaxified-cart-feedback').slideDown();
  };
  var _setText = function($button, label) {
    if ($button.children().length) {
      $button.children().each(function() {
        if ($.trim($(this).text()) !== '') {
          $(this).text(label);
        }
      });
    }
    else {
      $button.val(label).text(label);
    }
  };
  var _init = function() {
    $(document).ready(function() {

      function addToCartOk(quantity){
        $(_config.cartCountSelector).html(quantity);
      }

      function addAllItems(formData, array, addedtoCart){
        var quantity;

        $.getJSON('/cart.js', function(cart) {
           // now have access to Shopify cart object
          quantity = cart.item_count;
        } );

        Shopify.queue = [];

          Shopify.queue.push({
            primary: true,
            data: formData,
          });

          for (var i = 0; i < array.length; i++) {
            product = array[i]
            Shopify.queue.push({
              primary: false,
              variantId: product,
            });
                }
          Shopify.moveAlong = function(response) {
          // If we still have requests in the queue, let's process the next one.
            if (Shopify.queue.length) {
              var request = Shopify.queue.shift();

              if (!request.primary) {
                var data = 'id='+ request.variantId + '&quantity=1'
              } else {
                var data = request.data
              }

              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: data,
                success: function(res){
                  Shopify.moveAlong();
                  quantity += 1;
                  return res;
                },
                error: function(error){
                  if (Shopify.queue.length){
                    Shopify.moveAlong()
                  } else {
                    $(_config.cartCountSelector).html(quantity);
                  }
                  _showFeedback('error','<i class="fa fa-check"></i>' + error.responseJSON['description'],$(_config.addToCartFormSelector));
                }
              });
            }
           // If the queue is empty, we add 1 to cart
          else {
            quantity += 1;
            addToCartOk(quantity);
            addedtoCart();
           }
          };
          Shopify.moveAlong();
        };

        function getFormData($form){
          var unindexed_array = $form.serializeArray();
          var indexed_array = {};

          $.map(unindexed_array, function(n, i){
              indexed_array[n['name']] = n['value'];
          });

          return indexed_array;
      }

      $(_config.checkoutBtnSelector).click(function(e) {
        e.preventDefault();
        var data = getFormData($(_config.addToCartFormSelector)),
          formData = $(_config.addToCartFormSelector).serialize(),
          $addToCartBtn = $(_config.addToCartFormSelector).find(_config.addToCartBtnSelector),
          $checkoutBtn = $(_config.addToCartFormSelector).find(_config.checkoutBtnSelector),
          productType = $checkoutBtn.attr('data-product-type');

        _setText($checkoutBtn, _config.addingToCartBtnLabel);
        $addToCartBtn.addClass('disabled').prop('disabled', true);
        $checkoutBtn.addClass('disabled').prop('disabled', true);

        var currProd = parseInt(data.id),
          addItems = [],
          storeJson = $.parseJSON($('#shopify-features').html()),
          currStore = storeJson['domain'];
          // if(currStore === 'www.barkershoes.com' && (productType === 'Mens' || productType === 'Womens')) {
          //   var currPrice,
          //     minPrice = 30000,
          //     productJson = $.parseJSON($('[data-product-json]').html()),
          //     allWallets = Array(20483417735266,20483417768034,20483417800802),
          //     suedeExclude = ['calf', 'grain', 'patent', 'hand painted', 'shine'],
          //     shoePolish = 19113782116450,
          //     suedeBrush = 19116320817250,
          //     freeWallet = allWallets[Math.floor(Math.random()*allWallets.length)];
          //     productTitle = productJson['title'].toLowerCase(),
          //     productVariants = productJson['variants'];

          //   for( var i = 0, len = productVariants.length; i < len; i++ ) {
          //       if( productVariants[i]['id'] === currProd ) {
          //           currPrice = productVariants[i]['price'];
          //           break;
          //       }
          //   }

          //   if(currPrice >= minPrice) {
          //     addItems.push(freeWallet);
          //   }

          //   if(productTitle.indexOf('suede')) {
          //     if (suedeExclude.some(function(v) { return productTitle.indexOf(v) >= 0; })) {
          //       addItems.push(shoePolish);
          //     } else {
          //       addItems.push(suedeBrush);
          //     }
          //   } else {
          //     addItems.push(shoePolish);
          //   }
          // }

        addAllItems(formData, addItems, function() {
          _setText($checkoutBtn, _config.addedToCartBtnLabel);
            _showFeedback('success','<i class="fa fa-check"></i> Added to cart! <a href="/cart">View cart</a> or <a href="/collections/all">continue shopping</a>.',$(_config.addToCartFormSelector));
            window.setTimeout(function(){
              $addToCartBtn.prop('disabled', false).removeClass('disabled').removeClass('inverted');
              $checkoutBtn.prop('disabled', false).removeClass('disabled').removeClass('inverted');
              _setText($checkoutBtn,_config.checkoutBtnLabel);
              window.location.href = "/checkout";
            }, _config.howLongTillBtnReturnsToNormal);
        });

        return false;
      });

      $(_config.addToCartFormSelector).submit(function(e) {
        e.preventDefault();
        var data = getFormData($(_config.addToCartFormSelector)),
          formData = $(_config.addToCartFormSelector).serialize(),
          $addToCartBtn = $(_config.addToCartFormSelector).find(_config.addToCartBtnSelector),
          $checkoutBtn = $(_config.addToCartFormSelector).find(_config.checkoutBtnSelector),
          productType = $addToCartBtn.attr('data-product-type');

        _setText($addToCartBtn, _config.addingToCartBtnLabel);
        $addToCartBtn.addClass('disabled').prop('disabled', true);
        $checkoutBtn.addClass('disabled').prop('disabled', true);

        var currProd = parseInt(data.id),
          addItems = [],
          storeJson = $.parseJSON($('#shopify-features').html()),
          currStore = storeJson['domain'];

          // if(currStore === 'www.barkershoes.com' && (productType === 'Mens' || productType === 'Womens')) {
          //   var currPrice,
          //     minPrice = 30000,
          //     productJson = $.parseJSON($('[data-product-json]').html()),
          //     allWallets = Array(20483417735266,20483417768034,20483417800802),
          //     suedeExclude = ['calf', 'grain', 'patent', 'hand painted', 'shine'],
          //     shoePolish = 19113782116450,
          //     suedeBrush = 19116320817250,
          //     freeWallet = allWallets[Math.floor(Math.random()*allWallets.length)];
          //     productTitle = productJson['title'].toLowerCase(),
          //     productVariants = productJson['variants'];

          //   for( var i = 0, len = productVariants.length; i < len; i++ ) {
          //       if( productVariants[i]['id'] === currProd ) {
          //           currPrice = productVariants[i]['price'];
          //           break;
          //       }
          //   }

          //   if(currPrice >= minPrice) {
          //     addItems.push(freeWallet);
          //   }

          //   if(productTitle.indexOf('suede')) {
          //     if (suedeExclude.some(function(v) { return productTitle.indexOf(v) >= 0; })) {
          //       addItems.push(shoePolish);
          //     } else {
          //       addItems.push(suedeBrush);
          //     }
          //   } else {
          //     addItems.push(shoePolish);
          //   }
          // }

        addAllItems(formData, addItems, function() {
          _setText($addToCartBtn, _config.addedToCartBtnLabel);
            _showFeedback('success','<i class="fa fa-check"></i> Added to cart! <a href="/cart">View cart</a> or <a href="/collections/all">continue shopping</a>.',$(_config.addToCartFormSelector));
            window.setTimeout(function(){
              $addToCartBtn.prop('disabled', false).removeClass('disabled').removeClass('inverted');
              $checkoutBtn.prop('disabled', false).removeClass('disabled').removeClass('inverted');
              _setText($addToCartBtn,_config.addToCartBtnLabel);
              window.location.href = "/cart";
            }, _config.howLongTillBtnReturnsToNormal);
        });

        return false;
      });
    });
  };
  return {
    init: function(params) {
        // Configuration
        params = params || {};
        // Merging with defaults.
        $.extend(_config, params);
        // Action
        $(function() {
          _init();
        });
    },
    getConfig: function() {
      return _config;
    }
  }
})(jQuery);

Shopify.AjaxifyCart.init();
/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }
      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    checkout: '[data-checkout]',
    checkoutText: '[data-checkout-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    shopurlJson: '[data-shopurl-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var lightbox = $('.productImages a').simpleLightbox(),
      additionalImages = $('.additional-images'),
      mobileImages = $('.mobile-slider'),
      mobileimgNav = $('.mobile-image-nav'),
      maxWidth = 1024,
      windowWidth = $(window).width();

    $('.simple-lightbox').click(function(e) {
      e.preventDefault();
      lightbox.close();
    });

    $(lightbox).on('shown.simplelightbox', function () {
      $('.sl-image').click(function(e) {
        e.preventDefault();
        lightbox.close();
      });
    });

    additionalVar = {
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnFocus: false,
      dots: false,
      autoplay: true,
      arrows: true,
      infinite: false,
      centerMode: false,
      focusOnSelect: true,
      adaptiveHeight: true,
      cssEase: 'ease-in-out',
      responsive: [
        {
          breakpoint: maxWidth+1,
          settings: 'unslick'
        }
      ]
    };

    mimagesVar = {
      slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnFocus: false,
        dots: false,
        autoplay: false,
        arrows: false,
        infinite: false,
        centerMode: false,
        focusOnSelect: true,
        adaptiveHeight: true,
        asNavFor: mobileimgNav,
        cssEase: 'ease-in-out',
        mobileFirst: true,
        responsive: [
          {
            breakpoint: maxWidth,
            settings: 'unslick'
          }
        ]
    };

    mnavVar = {
      slidesToShow: 3,
      slidesToScroll: 1,
      pauseOnFocus: false,
      dots: false,
      autoplay: false,
      arrows: true,
      infinite: false,
      centerMode: false,
      focusOnSelect: true,
      adaptiveHeight: true,
      asNavFor: mobileImages,
      cssEase: 'ease-in-out',
      mobileFirst: true,
      responsive: [
        {
          breakpoint: maxWidth,
          settings: 'unslick'
        }
      ]
    };

    runSlick = function() {
      $(additionalImages).slick(additionalVar);
    };

    runmSlick = function() {
      $(mobileImages).slick(mimagesVar);
      $(mobileimgNav).slick(mnavVar);
    };

    if(windowWidth <= maxWidth) {
      runmSlick();
    } else {
      runSlick();
    }

    $(window).on('resize', function(){
      var windowWidth = $(window).width();
      if(windowWidth <= maxWidth) {
        if($(mobileImages).hasClass('slick-initialized')) return
        runmSlick();
      } else {
        if($(additionalImages).hasClass('slick-initialized')) return
        runSlick();
      }
    });

    $(mobileimgNav).find('.nav-image').click(function(e) {
      e.preventDefault();
      if(windowWidth > maxWidth) return
      $(mobileImages).slick('slickGoTo',$(this).index());
    });

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    this.shopUrl = JSON.parse($(selectors.shopurlJson, this.$container).html());

    var productJson = $.ajax({
      dataType: "json",
      async: false,
      url: this.shopUrl+'/products/'+this.productSingleObject.handle+'.json',
    }).responseJSON;

    this.productJson = productJson;

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.checkout, this.$container).prop('disabled', true);
        $(selectors.checkoutText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        $(selectors.checkout, this.$container).prop('disabled', false);
        $(selectors.checkoutText, this.$container).html(theme.strings.checkout);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
        $(selectors.checkout, this.$container).prop('disabled', true);
        $(selectors.checkoutText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ){
      if ( ns.includes("noPreventDefault") ) {
        this.addEventListener("touchstart", handle, { passive: false });
      } else {
        this.addEventListener("touchstart", handle, { passive: true });
      }
    }
  };

  jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ){
      if ( ns.includes("noPreventDefault") ) {
        this.addEventListener("touchmove", handle, { passive: false });
      } else {
        this.addEventListener("touchmove", handle, { passive: true });
      }
    }
  };

    function filterOff(clicked) {
    var count = 0;
    var hiddenFilters = false;
    $('.filter-list.shown').each( function() {
      if(!$(this).visible( false, true )) {
        hiddenFilters = true;
      }
    });

    if (hiddenFilters) {
      $($(".filter-list.shown").get().reverse()).each( function() {
        if(this != $(clicked)[0] && count == 0) {
          count++;
          $(this).removeClass('shown');
          $(this).addClass('collapsed').delay(300).queue(function(){
            filterOff(clicked);
            $( this ).dequeue();
          });
        }
      });
    }
  }

  $('.filtergroup-title').click(function(e) {
    e.preventDefault();
    if ($(this).parent().hasClass('collapsed')) {
      $(this).parent().removeClass('collapsed');
      $(this).parent().addClass('shown').delay(300).queue(function(){
        filterOff($(this));
        $( this ).dequeue();
      });
    } else {
      $(this).parent().addClass('collapsed');
      $(this).parent().removeClass('shown');
    }
  });

  var div, n,
      v = document.getElementsByClassName("video-container");
  for (n = 0; n < v.length; n++) {
      div = document.createElement("div");
      div.setAttribute("data-id", v[n].dataset.id);
      div.innerHTML = labnolThumb(v[n].dataset.id);
      div.onclick = labnolIframe;
      v[n].appendChild(div);
  }

  function labnolThumb(id) {
    var thumb = '<img class="lazyload" src="https://i.ytimg.com/vi/ID1/default.jpg" data-src="https://i.ytimg.com/vi/ID2/hqdefault.jpg" alt="Distinctly British">',
      play = '<div class="play"></div>';
    return thumb.replace("ID1", id).replace("ID2", id) + play;
  }

  function labnolIframe() {
    var iframe = document.createElement("iframe");
    var embed = "https://www.youtube.com/embed/ID?autoplay=1&loop=1&modestbranding=1&fs=0&controls=0&rel=0&playlist=ID";
    iframe.setAttribute("src", embed.replace(/ID/g, this.dataset.id));
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allowfullscreen", "1");
    this.parentNode.replaceChild(iframe, this);
  }

$('.store-switcher a').click(function(e) {
  e.preventDefault();
  var urlValue = $(this).attr('href').replace(/(^\w+:|^)\/\//, '');
  Cookies.set("pref_geo", urlValue, {
    expires: 14,
    secure: true,
    path: '/',
    domain: '.barkershoes.com'
  });
  //Remove the cookie which was set according to user's current location
  Cookies.remove("current_geo");
  window.top.location.href = 'https://' + urlValue;
});

function geolocateUser() {
  var currentWebsite = window.location.hostname,
    urlPrefix = 'https://',
    stores = [],
    prefGeo = Cookies.get("pref_geo"),
    currentGeo = Cookies.get('current_geo'),
    botPattern = "(googlebot\/|Chrome-Lighthouse|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)",
    re = new RegExp(botPattern, 'i');

  if (!re.test(navigator.userAgent)) {
    stores['gb'] = 'www.barkershoes.com';
    stores['eu'] = 'eu.barkershoes.com';
    stores['us'] = 'us.barkershoes.com';
    stores['row'] = 'row.barkershoes.com';
    stores['ru'] = 'ru.barkershoes.com';
    stores['dev'] = 'dev.barkershoes.com';
    var destLink = stores['gb'];

    if (prefGeo != currentWebsite) {
      if(prefGeo == undefined && (currentWebsite != currentGeo)) {
        $.ajax( {
          url: 'https://api.ipstack.com/check?access_key=9a6bf46d95ac0133687299fe30e834d7&fields=country_code,continent_name',
          type: 'POST',
          dataType: 'jsonp',
          success: function(location) {
            if(location.success == false) {
              return false;
            } else {
              console.info('location in uk temp='+location.country_code)
              switch(currentWebsite) {
                case stores['gb']:
                  // Set the cookie to current website
                  Cookies.set("current_geo", stores['gb']);
                  if(location.country_code != 'GB') {
                    if(location.continent_name == 'Europe') {
                      destLink = stores['eu'];
                    } else if (location.country_code == 'US') {
                      destLink = stores['us'];
                    } else if (location.country_code == 'RU') {
                      destLink = stores['ru'];
                    } else {
                      destLink = stores['row'];
                    }
                    // Overwrite the cookie for else block
                    Cookies.set("current_geo", destLink);
                    window.top.location.href = urlPrefix + destLink;
                  }
                break;
                case stores['eu']:
                  // Set the cookie to current website
                  Cookies.set("current_geo", stores['eu']);
                  if(location.continent_name != 'Europe' || location.country_code == 'GB') {
                    if(location.country_code == 'GB') {
                      destLink = stores['gb'];
                    } else if (location.country_code == 'US') {
                      destLink = stores['us'];
                    } else if (location.country_code == 'RU') {
                      destLink = stores['ru'];
                    } else {
                      destLink = stores['row'];
                    }
                    // Overwrite the cookie for else block
                    Cookies.set("current_geo", destLink);
                    window.top.location.href = urlPrefix + destLink;
                  }
                break;
                case stores['us']:
                  // Set the cookie to current website
                  Cookies.set("current_geo", stores['us']);
                  if(location.country_code != 'US') {
                    if(location.continent_name == 'Europe' && location.country_code != 'GB') {
                      destLink = stores['eu'];
                    } else if (location.country_code == 'GB') {
                      destLink = stores['gb'];
                    } else if (location.country_code == 'RU') {
                      destLink = stores['ru'];
                    } else {
                      destLink = stores['row'];
                    }
                    // Overwrite the cookie for else block
                    Cookies.set("current_geo", destLink);
                    window.top.location.href = urlPrefix + destLink;
                  }
                break;
                case stores['row']:
                  // Set the cookie to current website
                  Cookies.set("current_geo", stores['row']);
                  if(location.country_code == 'US' || location.continent_name == 'Europe') {
                    if(location.continent_name == 'Europe' && location.country_code != 'GB') {
                      destLink = stores['eu'];
                    } else if (location.country_code == 'GB') {
                      destLink = stores['gb'];
                    } else if (location.country_code == 'US') {
                      destLink = stores['us'];
                    } else if (location.country_code == 'RU') {
                      destLink = stores['ru'];
                    }
                    // Overwrite the cookie for else block
                    Cookies.set("current_geo", destLink);
                    window.top.location.href = urlPrefix + destLink;
                  }
                break;
                case stores['ru']:
                  // Set the cookie to current website
                  Cookies.set("current_geo", stores['ru']);
                  if(location.country_code != 'RU') {
                    if(location.continent_name == 'Europe' && location.country_code != 'GB') {
                      destLink = stores['eu'];
                    } else if(location.country_code == 'GB') {
                      destLink = stores['gb'];
                    } else if (location.country_code == 'US') {
                      destLink = stores['us'];
                    } else {
                      destLink = stores['row'];
                    }
                    // Overwrite the cookie for else block
                    Cookies.set("current_geo", destLink);
                    window.top.location.href = urlPrefix + destLink;
                  }
                break;
                case stores['dev']:
                  // if(location.continent_name == 'Europe' && location.country_code != 'GB') {
                  //   destLink = stores['eu'];
                  // } else if (location.country_code == 'GB') {
                  //   destLink = stores['gb'];
                  // } else if (location.country_code == 'US') {
                  //   destLink = stores['us'];
                  // } else {
                  //   destLink = stores['row'];
                  // }
                  // window.top.location.href = urlPrefix + destLink;
                break;
              }
            }
          }}
        );
      } else {
        if (prefGeo && prefGeo.endsWith('barkershoes.com')) {
          window.top.location.href = urlPrefix + prefGeo;
        }
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
}

geolocateUser();

  if (Cookies.get("grid_pref")) {
    if (Cookies.get("grid_pref") == 'gridm') {
      var querystring = 'view=gridm';
    } else if (Cookies.get("grid_pref") == 'gridsm') {
      var querystring = 'view=gridsm';
    } else {
      var querystring = 'view=grid';
    }
    $("a[href^='/collections']").each(function() {
      if ($(this).attr('href').indexOf('/products/') == -1) {
        var href = $(this).attr('href');
        if (href) {
            href += (href.match(/\?/) ? '&' : '?') + querystring;
            $(this).attr('href', href);
        }
      }
    });
  }

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  var homeSlider = $('.template-index .home-slider');

  function sizeHeader(){
    homeSlider = $('.template-index .home-slider');
    sliderItems = homeSlider.find('.slider-item')

    wHeight = $(window).height();

    if($(window).width() > 1024) {
      homeSlider.height(wHeight);

      $.each(sliderItems, function(){
        $(this).height(wHeight);
      })
    } else {
      homeSlider.height('auto');
      $.each(sliderItems, function(){
        $(this).height('auto');
      })
    }
  }

  window.barkerExit = {
    // Private variables
    shown: false,
    element: '#newsletter-popup',
    delay: 40,
    showOnDelay: true,
    cookieExp: 30,

    checkCookie: function() {
      // Handle cookie reset
      if (this.cookieExp <= 0) {
        Cookies.remove("popup_shown");
        return false;
      }
      // If cookie is set to true
      if (Cookies.get("popup_shown")) {
        return true;
      }
      return false;
    },
    showPopup: function() {
      // Show the popup
      if (this.shown) {
        return;
      }

      // Set Cookie
      Cookies.set("popup_shown", "value", {
        expires: this.cookieExp,
        secure: true
      });

      $('html, body').addClass('no-scroll');
      $(this.element).addClass('open-modal');

      this.shown = true;
    },

    // Load event listeners for the popup
    loadEvents: function() {
      // Track mouse movements
      document.addEventListener("mousemove", function(e) {
        // Get current scroll position
        var scroll = window.pageYOffset || document.documentElement.scrollTop;

        if ((e.pageY - scroll) < 7) {
          barkerExit.showPopup();
        }
      }, { passive: true });
    },
    setOptions: function(opts) {
      // Set user defined options for the popup
      this.element = (typeof opts.element === 'undefined') ? this.element : opts.element;
      this.delay = (typeof opts.delay === 'undefined') ? this.delay : opts.delay;
      this.showOnDelay = (typeof opts.showOnDelay === 'undefined') ? this.showOnDelay : opts.showOnDelay;
      this.cookieExp = (typeof opts.cookieExp === 'undefined') ? this.cookieExp : opts.cookieExp;
    },
    domReady: function(callback) {
      // Ensure the DOM has loaded
      if (document.readyState === "interactive" || document.readyState === "complete") {
        callback();
      } else {
        document.addEventListener("DOMContentLoaded", callback, {passive: true});
      }
    },
    init: function(opts) {
      // Initialize
      // Once the DOM has fully loaded
      this.domReady(function() {
        // Handle options
        if (typeof opts !== 'undefined') {
          barkerExit.setOptions(opts);
        }

        // Handle the cookie
        if (barkerExit.checkCookie()) {
          return;
        }
        barkerExit.loadEvents();

        // Load events
        setTimeout(function() {

          if (barkerExit.showOnDelay) {
            barkerExit.showPopup();
          }
        }, barkerExit.delay * 1000);
      });
    }
  };

  barkerExit.init({
    element: '#newsletter-popup',
    cookieExp: 14
  });

  $('.mobile-nav--has-dropdown .menu-link').click(function(e) {
    e.preventDefault();
    $(this).siblings('.mobile-submenu-nav').slideToggle('fast');
    $(this).parent().toggleClass('submenu-open');
  });

  $('.side-nav-toggle').click(function(e) {
    e.preventDefault();
    $('html, body').addClass('no-scroll');
    $(this.hash).addClass('nav-open');
  });

  $('.side-nav--close').click(function(e) {
    e.preventDefault();
    $(this).parents('.side-nav').removeClass('nav-open');
    $('html, body').removeClass('no-scroll');
  })

  $('.show-popup').click(function(e) {
    e.preventDefault();
    $('html, body').addClass('no-scroll');
    $(this.hash).addClass('open-modal');
  });

  $('.close-modal').click(function(e) {
    e.preventDefault();
    $(this).parents('.modal-overlay').removeClass('open-modal');
    $('html, body').removeClass('no-scroll');
  })

  $('.modal-overlay').click(function(e) {
    if (e.target !== this)
      return;
    e.preventDefault();
    $('.modal-overlay').removeClass('open-modal');
    $('html, body').removeClass('no-scroll');
  });

  homeSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnFocus: false,
    pauseOnHover: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    infinite: false,
    lazyLoad: 'ondemand',
    adaptiveHeight: true,
    mobileFirst: true,
    cssEase: 'ease-in-out',
    responsive: [
      {
        breakpoint: 989,
        settings: {
          dots: true
        }
      }
    ]
  });

  $('.arrowLeft').click(function(){
    homeSlider.slick('slickPrev');
  })

  $('.arrowRight').click(function(){
    homeSlider.slick('slickNext');
  })

  if ($('.template-index')) {
    sizeHeader();
  }

  $(window).resize(function() {
    if ($('.template-index')) {
      sizeHeader();
    }
  });

  if ($('.about-images')) {
    var lightbox = $('.about-image a').simpleLightbox();
  }

  if ($('.store-images')) {
    var lightbox = $('.store-image a').simpleLightbox();
  }

  var parallaxElements = [],
    ticking = false,
    headerObj = $('header[role="banner"]'),
    nav = $('header .header-inside nav[role="navigation"]'),
    scrollPoint = 180,
    headerObjHeight = headerObj.outerHeight();

  function headerNavAnim(scrollPos, lastScrollPos) {
    // Other on scroll events
    // Header animation
    if (scrollPos > lastScrollPos) {
      //scrolling down
      if (scrollPos <= 0 && scrollPos > lastScrollPos) {
        //ios rebound effect
        if (headerObj.hasClass('fixed')) {
          headerObj.removeClass('fixed');
        }
        if (headerObj.hasClass('hidefixed')) {
          headerObj.removeClass('hidefixed');
        }
      } else if (scrollPos < scrollPoint) {
        //scrolling down fix header
        if (!headerObj.hasClass('fixed')) {
          headerObj.addClass('fixed');
        }
      } else if (scrollPos >= scrollPoint) {
        //scrolled down past header so hide it
        if (headerObj.hasClass('fixed')) {
          headerObj.removeClass('fixed');
        }
        if (!headerObj.hasClass('hidefixed')) {
          headerObj.addClass('hidefixed');
        }
      }
    } else if (scrollPos < lastScrollPos-1) {
      //scrolling up
      if (scrollPos <= 5) {
        //at the top so removed fixed
        if (headerObj.hasClass('fixed') || headerObj.hasClass('hidefixed')) {
          headerObj.removeClass('fixed hidefixed');
        }
      } else {
        //scrolling up so show nav
        if (!headerObj.hasClass('fixed')) {
          headerObj.addClass('fixed');
        }
        if (headerObj.hasClass('hidefixed')) {
          headerObj.removeClass('hidefixed');
        }
      }
    }
  }

  headerNavAnim(window.scrollY, window.scrollY+10);

  function Scroller() {
    this.latestKnownScrollY = 0;
    this.ticking = false;
  }

  window.requestAnimFrame = (function() {
    return  window.requestAnimationFrame       ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame    ||
            function( callback ){
              window.setTimeout(callback, 1000 / 60);
            };
  })();

  Scroller.prototype = {
      init: function() {
        window.addEventListener('scroll', this.onScroll.bind(this), {passive: true});
      },
      onScroll: function() {
        this.latestKnownScrollY = window.scrollY;
        this.requestTick();
      },
      requestTick: function() {
        if( !this.ticking ) {
          window.requestAnimFrame(this.update.bind(this));
        }
        this.ticking = true;
      },
      update: function() {
        this.ticking = false;

        headerNavAnim(this.latestKnownScrollY, this.lastKnownScrollY);

        this.lastKnownScrollY = this.latestKnownScrollY;
      }
  };

  var scroller = new Scroller();
  scroller.init();

  // Search Form

  var searchShown = false;

  $('.header-searchbtn').click( function(e){
    e.preventDefault();

    if ($('.header-search').not(':visible')) {
      $('.header-search').slideDown('fast');
      $('.header-search input[type="search"]').focus();
      $( "body" ).append( "<div class='overlay'></div>" );
      $( "body>.overlay").fadeIn(300);
    }
  });

  $( document ).on( 'click touchstart', function ( e ) {
    if($(e.target).hasClass('header-searchbtn')) {
      return;
    } else {
      if ($('body>.overlay').is(':visible')) {
        if ( $( e.target ).closest( '.header-search' ).length === 0 ) {
            $( '.header-search' ).slideUp('fast');
            $( "body>.overlay").fadeOut(300, function() {
              $(this).remove();
            });
        }
      }
    }
  });

  $( document ).on( 'keydown', function ( e ) {
    if ($('.header-search').is(':visible')) {
      if ( e.keyCode === 27 ) { // ESC
          $( '.header-search' ).slideUp('fast');
          $( "body>.overlay").fadeOut(300, function() {
            $(this).remove();
          });
      }
    }
  });

  $('.icon-close').click( function(){
    $('body').removeClass('search-active');
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  slate.cart.onEditClick();
  slate.cart.handleInputQty();
});
